<div class="closeContainer">
    <i class="fa-sharp fa-regular fa-xmark closeIcon pointer" (click)="close()"></i>
</div>
<ng-container >
    <div  [ngSwitch]="type">
        <div *ngSwitchCase="'cancel'">
            <ng-container *ngTemplateOutlet="cancel"></ng-container>
        </div>
        <div *ngSwitchCase="'schedule'">
            <ng-container *ngTemplateOutlet="schedule"></ng-container>
        </div>
        <div *ngSwitchCase="'success'">
            <ng-container *ngTemplateOutlet="success"></ng-container>
        </div>
        <div *ngSwitchCase="'error'">
            <ng-container *ngTemplateOutlet="error"></ng-container>
        </div>
        <div *ngSwitchCase="'ticketSuccess'">
            <ng-container *ngTemplateOutlet="ticketSuccess"></ng-container>
        </div>
        <div *ngSwitchCase="'ticketError'">
            <ng-container *ngTemplateOutlet="ticketError"></ng-container>
        </div>
        <div *ngSwitchCase="'createTicket'">
            <ng-container *ngTemplateOutlet="createTicket"></ng-container>
        </div>
        <div *ngSwitchCase="'scoreError'">
            <ng-container *ngTemplateOutlet="scoreError"></ng-container>
        </div>
        <div *ngSwitchCase="'scoreSuccess'">
            <ng-container *ngTemplateOutlet="scoreSuccess"></ng-container>
        </div>
    </div>
</ng-container>


<ng-template #ticketError>
    <div class="ticketMessage">
        <img src="./assets/img/ticket_error.svg">
        <div class="ticketTitle">{{ 'FORM.REQUEST_FORM.FAIL.TITLE' | translate }}</div>
        <div class="ticketText">{{ 'FORM.REQUEST_FORM.FAIL.TEXT' | translate }}</div>
    </div>
    <div class="footer">
        <button class="home365-button primary flex center-vr" (click)="submit()">
            {{'FORM.REQUEST_FORM.FAIL.BUTTON' | translate}}
        </button>
    </div>
</ng-template>


<ng-template #scoreError>
    <div class="ticketMessage">
        <img class="smallImg" src="./assets/img/error.svg">
        <div class="ticketTitle center">{{ 'SERVICE_REVIEW.FAIL_MESSAGE_TEXT' | translate }}</div>
    </div>
    <div class="footer">
        <button class="home365-button primary flex center-vr" (click)="close()">
            {{'FORM.REQUEST_FORM.FAIL.BUTTON' | translate}}
        </button>
    </div>
</ng-template>

<ng-template #ticketSuccess>
    <div class="ticketMessage">
        <img src="./assets/img/ticket_success.svg">
        <div class="ticketTitle">{{ 'FORM.REQUEST_FORM.SUCESS.TITLE' | translate }}</div>
        <div class="ticketText">{{ 'FORM.REQUEST_FORM.SUCESS.TEXT' | translate }}</div>
    </div>
    <div class="footer">
        <button class="home365-button primary flex center-vr" (click)="submit()">
            {{'FORM.REQUEST_FORM.SUCESS.BUTTON' | translate}}
        </button>
    </div>
</ng-template>

<ng-template #scoreSuccess>
    <div class="ticketMessage">
        <img class="smallImg" src="./assets/img/success.svg">
        <div class="ticketText center">{{ 'SERVICE_REVIEW.SUCCESS_MESSAGE_TITLE' | translate }}</div>
        <div class="ticketText center">{{ 'SERVICE_REVIEW.SUCCESS_MESSAGE_TEXT' | translate }}</div>
    </div>
</ng-template>

<ng-template #schedule>
    <div class="schedule">
        <div class="title" [ngClass]="{'mobileTitle': isMobile}">
            {{ 'MY_SHOWINGS.RESCHEDULE.TITLE' | translate | translateCut: 0 }}
            <span class="prettyLetters" >{{ 'MY_SHOWINGS.RESCHEDULE.TITLE' | translate | translateCut: 1 }}</span>
        </div>
        <div class="subTitle" [ngClass]="{'mobileSubTitle': isMobile}">
            {{ 'MY_SHOWINGS.RESCHEDULE.REMARK' | translate: {propertyAddress: showingData?.propertyAddress} | translateCut: 0 }}
            <span class="primaryColor">{{ 'MY_SHOWINGS.RESCHEDULE.REMARK' | translate: {propertyAddress: showingData?.propertyAddress
              }  | translateCut: 1 }}</span>
            {{ 'MY_SHOWINGS.RESCHEDULE.REMARK' | translate: {propertyAddress: showingData?.propertyAddress}  | translateCut: 2 }}
        </div>
        <div class="inputRow" [ngClass]="{'inputRowMobile': isMobile}">
            <mat-form-field class="flex1" id="dateInput">
                <input placeholder="{{'MY_SHOWINGS.DATE_INPUT' | translate}}" class="inputWithIcon" (click)="picker.open()" matInput [min]="startDate" [formControl]="dateInput" [matDatepicker]="picker" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': dateInput?.errors?.['required'] && dateInput?.dirty}" />
                <mat-datepicker #picker ></mat-datepicker>
                <mat-datepicker-toggle matSuffix [for]="picker">
                    <mat-icon matDatepickerToggleIcon><img src="./assets/img/date.svg"></mat-icon>
                </mat-datepicker-toggle>
            </mat-form-field>
            <mat-form-field class="flex1" id="timeInput">
                <mat-label>{{'MY_SHOWINGS.TIME_INPUT' | translate}}</mat-label>
                <mat-select class="lastInput" matInput [formControl]="timeInput" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': timeInput?.errors?.['required'] && timeInput?.dirty}" [ngClass]="{'mobileLastInput mobileSelect': isMobile}">
                    <mat-option *ngFor="let item of timeArray" [value]="item">
                        {{item}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="footer">
            <button class="home365-button primary flex center-vr" (click)="submit()">
                {{'GENERAL_TEXTS.CONFIRM_BUTTON' | translate}}
            </button>
        </div>
    </div>
    
</ng-template>

<ng-template #cancel>
    <div class="title">
        {{'MY_SHOWINGS.CONFIRM_CANCELATION_TITLE' | translate }}
    </div>
    <div class="body">
        {{'MY_SHOWINGS.CONFIRM_CANCELATION_TEXT' | translate: {date: date, time: time} }}
    </div>
    <div class="footer">
        <button class="home365-button primary flex center-vr" (click)="submit()">
            {{'GENERAL_TEXTS.CONFIRM_BUTTON' | translate}}
        </button>
    </div>
</ng-template>

<ng-template #success>
    <div class="successImg">
        <img src="./assets/img/success.svg" alt="">
    </div>
    <div class="smallTitle">
        {{'MY_SHOWINGS.SUCCESS' | translate }}
    </div>
</ng-template>

<ng-template #error>
    <div class="successImg">
        <img src="./assets/img/error.svg" alt="">
    </div>
    <div class="smallTitle">
        {{'MY_SHOWINGS.ERROR' | translate }}
    </div>
</ng-template>

<ng-template #createTicket>
    <iframe [src]="createTicketSrc | safe" frameborder="0"></iframe>
</ng-template>


<div *ngIf="type === 'createTicket'" class="triangle" [ngClass]="{'mobile_triangle': isMobile}"
     #triangle></div>
